import { UnsubscribeOnDestroyAdapter } from "./unsubscribe-ondestory.adapter";

export class SkyKickComponent extends UnsubscribeOnDestroyAdapter {

}
